export default "__VITE_ASSET__DA7OVVu9__"